<div class="screen-loader p-48">
    <mat-spinner [diameter]="56"></mat-spinner>
    <div class="title">
        <div matDialogTitle>{{title}}</div>
        <div [innerHTML]="content" mat-dialog-content></div>
    </div>
</div>
